import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "grid w-full grid-cols-1 sm:grid-cols-2" }
const _hoisted_2 = { class: "flex w-full flex-col items-center bg-gray-50 px-8 pt-20 sm:items-start sm:justify-center sm:pt-0 lg:px-28 xl:px-40" }
const _hoisted_3 = { class: "mb-4 text-center text-2xl font-semibold text-gray-700" }
const _hoisted_4 = { class: "mb-6 max-w-xl text-center text-sm" }
const _hoisted_5 = {
  key: 0,
  class: "mb-4 flex w-full justify-center"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "flex w-full max-w-sm flex-col items-center gap-3" }
const _hoisted_8 = { class: "flex items-center gap-2 self-start text-sm text-gray-600" }
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiLoadingDialog = _resolveComponent("UiLoadingDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "bg-primary relative hidden w-full items-center justify-center sm:flex" }, [
        _createElementVNode("span", { class: "login-bg h-[150px] xl:h-[250px]" })
      ], -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_2, [
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "login-logo mb-8 w-[225px]" }, null, -1 /* CACHED */)),
        _createElementVNode("h3", _hoisted_3, _toDisplayString($setup.t('authentication.2fa.title')), 1 /* TEXT */),
        _createElementVNode("p", _hoisted_4, _toDisplayString($setup.t('authentication.2fa.description')), 1 /* TEXT */),
        ($setup.qrCodeUrl)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("img", {
                src: $setup.qrCodeUrl,
                alt: "2FA QR Code",
                class: "h-48 w-48"
              }, null, 8 /* PROPS */, _hoisted_6)
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.formState.code) = $event)),
            type: "text",
            inputmode: "numeric",
            maxlength: "6",
            placeholder: "123456",
            onKeydown: _withKeys($setup.verify, ["enter"]),
            class: "w-full rounded border border-gray-300 px-3 py-2 text-center text-lg tracking-widest focus:outline-none focus:ring-2 focus:ring-blue-500"
          }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
            [_vModelText, $setup.formState.code]
          ]),
          _createElementVNode("label", _hoisted_8, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.formState.remember) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelCheckbox, $setup.formState.remember]
            ]),
            _createElementVNode("span", null, _toDisplayString($setup.t('authentication.2fa.form.rememberMe')), 1 /* TEXT */)
          ]),
          _createElementVNode("button", {
            class: "w-full rounded bg-blue-600 px-4 py-2 font-semibold text-white hover:bg-blue-700 disabled:opacity-50",
            disabled: !$setup.formState.code,
            onClick: $setup.verify
          }, _toDisplayString($setup.t('authentication.2fa.form.verify')), 9 /* TEXT, PROPS */, _hoisted_9)
        ])
      ])
    ]),
    _createVNode(_component_UiLoadingDialog, {
      show: $setup.uiStore.isLoading,
      text: _ctx.$t('ui-loading-dialog-text')
    }, null, 8 /* PROPS */, ["show", "text"])
  ], 64 /* STABLE_FRAGMENT */))
}